import { B as je, b as Re, D as Fe, F as Ve, a as _e, H as $e, L as Ye, N as Ke, P as He, c as Je, d as Xe, S as ze, e as Ze, T as Ge, g as Qe, V as We, Y as qe, f as et, s as tt, t as ot } from "./TrailingNode-Dyk86U-N.js";
import { PluginKey as R, Plugin as F } from "@tiptap/pm/state";
import { c as m, a as V } from "./BlockNoteExtension-C2X7LW-V.js";
import * as l from "@y/y";
import { a2 as L, _ } from "./defaultBlocks-BYnRIQtu.js";
import { ae as st, af as rt, ah as at, ag as it, ad as ct } from "./defaultBlocks-BYnRIQtu.js";
import { yCursorPlugin as $, defaultSelectionBuilder as Y, redoCommand as K, undoCommand as H, yUndoPlugin as J, ySyncPluginKey as f, findTypeInOtherYdoc as M } from "@y/prosemirror";
import { S as ut } from "./ShowSelection-Dz-NEase.js";
import { getMarkRange as X, posToDOMRect as z } from "@tiptap/core";
import { v4 as Z } from "uuid";
const D = (e, t) => {
  t(e), e.forEach((o) => {
    o instanceof l.XmlElement && D(o, t);
  });
}, G = (e, t) => {
  const o = /* @__PURE__ */ new Map();
  return e.forEach((s) => {
    s instanceof l.XmlElement && D(s, (n) => {
      if (n.nodeName === "blockContainer" && n.hasAttribute("id")) {
        const r = n.getAttribute("textColor"), i = n.getAttribute("backgroundColor"), a = {
          textColor: r === L.textColor.default ? void 0 : r,
          backgroundColor: i === L.backgroundColor.default ? void 0 : i
        };
        (a.textColor || a.backgroundColor) && o.set(n.getAttribute("id"), a);
      }
    });
  }), o.size === 0 ? !1 : (t.doc.descendants((s, n) => {
    if (s.type.name === "blockContainer" && o.has(s.attrs.id)) {
      const r = t.doc.nodeAt(n + 1);
      if (!r)
        throw new Error("No element found");
      t.setNodeMarkup(n + 1, void 0, {
        // preserve existing attributes
        ...r.attrs,
        // add the textColor and backgroundColor attributes
        ...o.get(s.attrs.id)
      });
    }
  }), !0);
}, Q = [G], Le = m(
  ({ options: e }) => {
    let t = !1;
    const o = new R("schemaMigration");
    return {
      key: "schemaMigration",
      prosemirrorPlugins: [
        new F({
          key: o,
          appendTransaction: (s, n, r) => {
            if (t || // If any of the transactions are not due to a yjs sync, we don't need to run the migration
            !s.some((a) => a.getMeta("y-sync$")) || // If none of the transactions result in a document change, we don't need to run the migration
            s.every((a) => !a.docChanged) || // If the fragment is still empty, we can't run the migration (since it has not yet been applied to the Y.Doc)
            !e.fragment.firstChild)
              return;
            const i = r.tr;
            for (const a of Q)
              a(e.fragment, i);
            if (t = !0, !!i.docChanged)
              return i;
          }
        })
      ]
    };
  }
);
function N(e) {
  const t = e.charAt(0) === "#" ? e.substring(1, 7) : e, o = parseInt(t.substring(0, 2), 16), s = parseInt(t.substring(2, 4), 16), n = parseInt(t.substring(4, 6), 16), i = [o / 255, s / 255, n / 255].map((c) => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  return 0.2126 * i[0] + 0.7152 * i[1] + 0.0722 * i[2] <= 0.179;
}
function W(e) {
  const t = document.createElement("span");
  t.classList.add("bn-collaboration-cursor__base");
  const o = document.createElement("span");
  o.setAttribute("contentedEditable", "false"), o.classList.add("bn-collaboration-cursor__caret"), o.setAttribute(
    "style",
    `background-color: ${e.color}; color: ${N(e.color) ? "white" : "black"}`
  );
  const s = document.createElement("span");
  return s.classList.add("bn-collaboration-cursor__label"), s.setAttribute(
    "style",
    `background-color: ${e.color}; color: ${N(e.color) ? "white" : "black"}`
  ), s.insertBefore(document.createTextNode(e.name), null), o.insertBefore(s, null), t.insertBefore(document.createTextNode("⁠"), null), t.insertBefore(o, null), t.insertBefore(document.createTextNode("⁠"), null), t;
}
const Me = m(
  ({ options: e }) => {
    const t = /* @__PURE__ */ new Map(), o = e.provider && "awareness" in e.provider && typeof e.provider.awareness == "object" ? e.provider.awareness : void 0;
    return o && ("setLocalStateField" in o && typeof o.setLocalStateField == "function" && o.setLocalStateField("user", e.user), "on" in o && typeof o.on == "function" && e.showCursorLabels !== "always" && o.on(
      "change",
      ({
        updated: s
      }) => {
        for (const n of s) {
          const r = t.get(n);
          r && (r.element.setAttribute("data-active", ""), r.hideTimeout && clearTimeout(r.hideTimeout), t.set(n, {
            element: r.element,
            hideTimeout: setTimeout(() => {
              r.element.removeAttribute("data-active");
            }, 2e3)
          }));
        }
      }
    )), {
      key: "yCursor",
      prosemirrorPlugins: [
        o ? $(o, {
          selectionBuilder: Y,
          cursorBuilder(s, n) {
            let r = t.get(n);
            if (!r) {
              const i = (e.renderCursor ?? W)(s);
              e.showCursorLabels !== "always" && (i.addEventListener("mouseenter", () => {
                const a = t.get(n);
                a.element.setAttribute("data-active", ""), a.hideTimeout && (clearTimeout(a.hideTimeout), t.set(n, {
                  element: a.element,
                  hideTimeout: void 0
                }));
              }), i.addEventListener("mouseleave", () => {
                const a = t.get(n);
                t.set(n, {
                  element: a.element,
                  hideTimeout: setTimeout(() => {
                    a.element.removeAttribute("data-active");
                  }, 2e3)
                });
              })), r = {
                element: i,
                hideTimeout: void 0
              }, t.set(n, r);
            }
            return r.element;
          }
        }) : void 0
      ].filter(Boolean),
      dependsOn: ["ySync"],
      updateUser(s) {
        o == null || o.setLocalStateField("user", s);
      }
    };
  }
), Ne = m(() => ({
  key: "yUndo",
  prosemirrorPlugins: [J()],
  dependsOn: ["yCursor", "ySync"],
  undoCommand: H,
  redoCommand: K
}));
let g;
async function q() {
  return g || (g = (async () => {
    const [e, t] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), o = "default" in e ? e.default : e, s = "default" in t ? t.default : t;
    return await o.init({ data: s }), { emojiMart: o, emojiData: s };
  })(), g);
}
async function Pe(e, t) {
  if (!("text" in e.schema.inlineContentSchema) || e.schema.inlineContentSchema.text !== _.text)
    return [];
  const { emojiData: o, emojiMart: s } = await q();
  return (t.trim() === "" ? Object.values(o.emojis) : await s.SearchIndex.search(t)).map((r) => ({
    id: r.skins[0].native,
    onItemClick: () => e.insertInlineContent(r.skins[0].native + " ")
  }));
}
const Be = m(({ editor: e }) => {
  function t(n) {
    let r = e.prosemirrorView.nodeDOM(n);
    for (; r && r.parentElement; ) {
      if (r.nodeName === "INS" || r.nodeName === "DEL")
        return r;
      r = r.parentElement;
    }
    return null;
  }
  function o(n, r) {
    return e.transact((i) => {
      const a = i.doc.resolve(n), c = a.marks().find((S) => S.type.name === r);
      if (!c)
        return;
      const d = X(a, c.type);
      if (d)
        return {
          range: d,
          mark: c,
          get text() {
            return i.doc.textBetween(d.from, d.to);
          },
          get position() {
            return z(
              e.prosemirrorView,
              d.from,
              d.to
            ).toJSON();
          }
        };
    });
  }
  function s() {
    return e.transact((n) => {
      const r = n.selection;
      if (r.empty)
        return o(r.anchor, "insertion") || o(r.anchor, "deletion") || o(r.anchor, "modification");
    });
  }
  return {
    key: "suggestions",
    runsBefore: ["ySync"],
    showSuggestions: () => {
      const n = f.getState(e.prosemirrorState);
      if (!n)
        throw new Error("ySync plugin state not found");
      n.setSuggestionMode("view");
    },
    enableSuggestions: () => {
      const n = f.getState(e.prosemirrorState);
      if (!n)
        throw new Error("ySync plugin state not found");
      n.setSuggestionMode("edit");
    },
    disableSuggestions: () => {
      const n = f.getState(e.prosemirrorState);
      if (!n)
        throw new Error("ySync plugin state not found");
      n.setSuggestionMode("off");
    },
    applySuggestion: (n, r) => {
      const i = f.getState(e.prosemirrorState);
      if (!i)
        throw new Error("ySync plugin state not found");
      i.acceptChanges(n, r);
    },
    revertSuggestion: (n, r) => {
      const i = f.getState(e.prosemirrorState);
      if (!i)
        throw new Error("ySync plugin state not found");
      i.rejectChanges(n, r);
    },
    applyAllSuggestions: () => {
      const n = f.getState(e.prosemirrorState);
      if (!n)
        throw new Error("ySync plugin state not found");
      n.acceptAllChanges();
    },
    revertAllSuggestions: () => {
      const n = f.getState(e.prosemirrorState);
      if (!n)
        throw new Error("ySync plugin state not found");
      n.rejectAllChanges();
    },
    getSuggestionElementAtPos: t,
    getMarkAtPos: o,
    getSuggestionAtSelection: s,
    getSuggestionAtCoords: (n) => e.transact(() => {
      const r = e.prosemirrorView.posAtCoords(n);
      if (!(r === null || (r == null ? void 0 : r.inside) === -1))
        return o(r.pos, "insertion") || o(r.pos, "deletion") || o(r.pos, "modification");
    }),
    checkUnresolvedSuggestions: () => {
      let n = !1;
      return e.prosemirrorState.doc.descendants((r) => n ? !1 : (n = r.marks.findIndex(
        (i) => i.type.name === "insertion" || i.type.name === "deletion" || i.type.name === "modification"
      ) !== -1, !0)), n;
    }
  };
}), De = m(
  ({
    editor: e,
    options: { endpoints: t, fragment: o }
  }) => {
    const s = V({
      snapshots: [],
      selectedSnapshotId: void 0
    }), n = async () => {
      const a = await t.listSnapshots();
      s.setState((c) => ({
        ...c,
        snapshots: a
      }));
    }, r = async () => {
      if (await n(), s.state.snapshots.length > 0) {
        const a = await t.fetchSnapshotContent(
          s.state.snapshots[0].id
        );
        l.applyUpdateV2(o.doc, a);
      }
    }, i = async (a, c) => {
      var T, A;
      if (s.setState((y) => ({
        ...y,
        selectedSnapshotId: a
      })), a === void 0) {
        (T = f.getState(e.prosemirrorState)) == null || T.resumeSync();
        return;
      }
      let d;
      if (c) {
        const y = await t.fetchSnapshotContent(c), k = new l.Doc({ isSuggestionDoc: !0 });
        l.applyUpdateV2(k, y), d = {
          fragment: M(o, k)
        };
      }
      const S = await t.fetchSnapshotContent(a), x = new l.Doc();
      l.applyUpdateV2(x, S), (A = f.getState(e.prosemirrorState)) == null || A.renderSnapshot(
        { fragment: M(o, x) },
        d,
        [
          l.createAttributionItem("insert", ["John Doe"])
          // Y.createAttributionItem("delete", ["John Doe"]),
        ]
      );
    };
    return {
      key: "versioning",
      store: s,
      mount: () => {
        r();
      },
      listSnapshots: async () => (await n(), s.state.snapshots),
      createSnapshot: async (a) => (await t.createSnapshot(o, a), await n(), s.state.snapshots[0]),
      canRestoreSnapshot: t.restoreSnapshot !== void 0,
      restoreSnapshot: t.restoreSnapshot ? async (a) => {
        throw i(void 0), new Error("Not implemented");
      } : void 0,
      canUpdateSnapshotName: t.updateSnapshotName !== void 0,
      updateSnapshotName: t.updateSnapshotName ? async (a, c) => {
        await t.updateSnapshotName(a, c), await n();
      } : void 0,
      selectSnapshot: async (a, c) => {
        await i(a, c);
      }
    };
  }
), ee = String.fromCharCode, te = (e) => e.toLowerCase(), oe = /^\s*/g, ne = (e) => e.replace(oe, ""), se = /([A-Z])/g, P = (e, t) => ne(e.replace(se, (o) => `${t}${te(o)}`));
typeof TextEncoder < "u" && new TextEncoder();
let w = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
w && w.decode(new Uint8Array()).length === 1 && (w = null);
const C = () => /* @__PURE__ */ new Map(), B = (e) => e === void 0 ? null : e;
class re {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem(t, o) {
    this.map.set(t, o);
  }
  /**
   * @param {string} key
   */
  getItem(t) {
    return this.map.get(t);
  }
}
let O = new re(), ae = !0;
try {
  typeof localStorage < "u" && localStorage && (O = localStorage, ae = !1);
} catch {
}
const ie = O, ce = (e, t) => t.includes(e), p = typeof process < "u" && process.release && /node|io\.js/.test(process.release.name) && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]", I = typeof window < "u" && typeof document < "u" && !p;
let u;
const le = () => {
  if (u === void 0)
    if (p) {
      u = C();
      const e = process.argv;
      let t = null;
      for (let o = 0; o < e.length; o++) {
        const s = e[o];
        s[0] === "-" ? (t !== null && u.set(t, ""), t = s) : t !== null && (u.set(t, s), t = null);
      }
      t !== null && u.set(t, "");
    } else typeof location == "object" ? (u = C(), (location.search || "?").slice(1).split("&").forEach((e) => {
      if (e.length !== 0) {
        const [t, o] = e.split("=");
        u.set(`--${P(t, "-")}`, o), u.set(`-${P(t, "-")}`, o);
      }
    })) : u = C();
  return u;
}, b = (e) => le().has(e), E = (e) => B(p ? process.env[e.toUpperCase().replaceAll("-", "_")] : ie.getItem(e)), U = (e) => b("--" + e) || E(e) !== null;
U("production");
const ue = p && ce(process.env.FORCE_COLOR, ["true", "1", "2"]);
ue || !b("--no-colors") && // @todo deprecate --no-colors
!U("no-color") && (!p || process.stdout.isTTY) && (!p || b("--color") || E("COLORTERM") !== null || (E("TERM") || "").includes("color"));
const de = (e) => new Uint8Array(e), fe = (e, t, o) => new Uint8Array(e, t, o), pe = (e) => {
  let t = "";
  for (let o = 0; o < e.byteLength; o++)
    t += ee(e[o]);
  return btoa(t);
}, me = (e) => Buffer.from(e.buffer, e.byteOffset, e.byteLength).toString("base64"), ge = (e) => {
  const t = atob(e), o = de(t.length);
  for (let s = 0; s < t.length; s++)
    o[s] = t.charCodeAt(s);
  return o;
}, he = (e) => {
  const t = Buffer.from(e, "base64");
  return fe(t.buffer, t.byteOffset, t.byteLength);
}, Se = I ? pe : me, ye = I ? ge : he, h = async () => JSON.parse(localStorage.getItem("snapshots") ?? "[]"), v = async (e, t, o) => {
  const s = {
    id: Z(),
    name: t,
    createdAt: Date.now(),
    updatedAt: Date.now(),
    meta: {
      restoredFromSnapshotId: o,
      userIds: ["User1"],
      contents: Se(l.encodeStateAsUpdateV2(e.doc))
    }
  };
  return localStorage.setItem(
    "snapshots",
    JSON.stringify([s, ...await h()])
  ), Promise.resolve(s);
}, j = async (e) => {
  const o = (await h()).find(
    (s) => s.id === e
  );
  if (o === void 0)
    throw new Error(`Document snapshot ${e} could not be found.`);
  if (!("contents" in o.meta))
    throw new Error(`Document snapshot ${e} doesn't contain content.`);
  if (typeof o.meta.contents != "string")
    throw new Error(`Document snapshot ${e} contains invalid content.`);
  return Promise.resolve(ye(o.meta.contents));
}, we = async (e, t) => {
  await v(e, "Backup");
  const o = await j(t), s = new l.Doc();
  return l.applyUpdateV2(s, o), await v(s.getXmlFragment(), "Restored Snapshot", t), o;
}, Ce = async (e, t) => {
  const o = await h(), s = o.find(
    (n) => n.id === e
  );
  if (s === void 0)
    throw new Error(`Document snapshot ${e} could not be found.`);
  return s.name = t, s.updatedAt = Date.now(), localStorage.setItem("snapshots", JSON.stringify(o)), Promise.resolve();
}, Oe = {
  listSnapshots: h,
  createSnapshot: v,
  fetchSnapshotContent: j,
  restoreSnapshot: we,
  updateSnapshotName: Ce
};
export {
  je as BlockChangeExtension,
  Re as DEFAULT_LINK_PROTOCOL,
  Fe as DropCursorExtension,
  st as FilePanelExtension,
  Ve as ForkYDocExtension,
  _e as FormattingToolbarExtension,
  $e as HistoryExtension,
  Ye as LinkToolbarExtension,
  Ke as NodeSelectionKeyboardExtension,
  He as PlaceholderExtension,
  Je as PreviousBlockTypeExtension,
  Le as SchemaMigration,
  ut as ShowSelectionExtension,
  Xe as SideMenuExtension,
  ze as SideMenuView,
  rt as SuggestionMenu,
  Be as SuggestionsExtension,
  Ze as TableHandlesExtension,
  Ge as TableHandlesView,
  Qe as TrailingNodeExtension,
  We as VALID_LINK_PROTOCOLS,
  De as VersioningExtension,
  Me as YCursorExtension,
  qe as YSyncExtension,
  Ne as YUndoExtension,
  at as filterSuggestionItems,
  et as findTypeInOtherYdoc,
  Pe as getDefaultEmojiPickerItems,
  it as getDefaultSlashMenuItems,
  ct as insertOrUpdateBlockForSlashMenu,
  Oe as localStorageEndpoints,
  tt as sideMenuPluginKey,
  ot as tableHandlesPluginKey
};
//# sourceMappingURL=extensions.js.map
